export default {
    container: {
        cursor: 'pointer'
    }
}